export const firebaseConfig = {
  apiKey: 'AIzaSyA9T0Nsnsrx9OiUk2bhE5zqgAanhQXQfq0',
  authDomain: 'fit-prd.firebaseapp.com',
  projectId: 'fit-prd',
  storageBucket: 'fit-prd.appspot.com',
  messagingSenderId: '596072060783',
  appId: '1:596072060783:web:c33afe0975ffe2e37a7a9a',
  measurementId: 'G-088170BCJQ',
}
